import controller_0 from '@symfony/ux-chartjs/dist/controller.js';
import controller_1 from '@symfony/ux-live-component/dist/live_controller.js';
import '@symfony/ux-live-component/dist/live.min.css';
import controller_2 from '@symfony/ux-react/dist/render_controller.js';
export default {
  'symfony--ux-chartjs--chart': controller_0,
  'live': controller_1,
  'symfony--ux-react--react': controller_2,
};